import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Form, Table, Card, Button } from 'react-bootstrap';
import BuFundRow from './row';

const BuFundForm = props => {
  const { t } = useTranslation();

  const [buFundOptions, setBuFundOptions] = useState([]);

  useEffect(() => {
    renderBuFundRows();
  }, [props]);

  const renderBuFundRows = () => {
    if (!props.buFundData) return;

    setBuFundOptions(
      props.buFundData.map((value, key) => {
        return (
          <BuFundRow
            key={key}
            buFundRowPosition={key}
            buFundData={props.buFundData}
            removeBuValues={removeBuValues}
            buFundDetails={value}
          ></BuFundRow>
        );
      })
    );
  };

  const AddBuFundRow = () => {
    let data = props.buFundData;
    data.push({});

    props.setBuFundData(data);

    renderBuFundRows();
  };

  const removeBuValues = key => {
    let result = props.buFundData.filter((data, index) => {
      return index != key;
    });

    props.setBuFundData(result);

    renderBuFundRows();
  };

  return (
    <>
      <Row>
        <Col>
          <Row className="mb-2">
            <Col>
              <h5>{t('title:BU')}</h5>
            </Col>
          </Row>
          <Row className="mt-12 pull-right">
            <Col>
              <Button
                size="sm"
                variant="dark"
                className="float-left mb-2"
                onClick={e => AddBuFundRow()}
              >
                <i className="fas fa-plus" />
                {t('label:add BU')}
              </Button>
            </Col>
          </Row>
          <div className="table-mobile-transform">
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th className="text-center align-middle">{t('label:BU')}</th>
                  <th className="text-center align-middle">
                    {t('label:BU verb percentage')}
                  </th>
                  <th className="text-center align-content-center">
                    {t('label:actions')}
                  </th>
                </tr>
              </thead>
              <tbody>{buFundOptions}</tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BuFundForm;
